/**
 * Info
 * A module is meant to be rendered by pages
 * (maybe wrapped into one or more Layouts)
 * A module should render components, passinng data to them.
 * @class Info
 * @param {object} props - Props
 */

import React, { useMemo } from "react";
import { graphql } from "gatsby";
import Accordion from "../components/accordion";
import { Link } from "../components/link";
import slugify from "@sindresorhus/slugify";

const Info = ({ data, isFirst }) => {
  const { preTitle, infoTitle, abstract, cta, accordion } = data;
  const sortedItems = useMemo(
    () =>
      accordion?.sort((a, b) => {
        const posA = parseInt(a?.position?.length ? a.position[0] : 0);
        const posB = parseInt(b?.position?.length ? b.position[0] : 0);
        return !isNaN(posA) && !isNaN(posB)
          ? posA - posB
          : isNaN(posA) && isNaN(posB)
          ? 0
          : isNaN(posA)
          ? 1
          : -1;
      }),
    [accordion]
  );
  return (
    <>
      {data?.anchorTitleDesktop && (
        <span id={slugify(data.anchorTitleDesktop)} className="tabs__scroll-anchor" />
      )}
      <div className="container">
        <div className="info-container">
          <div className="info-container__primary">
            {preTitle && <p className="info-container__preTitle">{preTitle}</p>}
            {infoTitle && isFirst ? (
              <h1 className="info-container__title">{infoTitle}</h1>
            ) : infoTitle && !isFirst ? (
              <p className="info-container__title">{infoTitle}</p>
            ) : null}
            {abstract && <p className="info-container__description">{abstract}</p>}
            {cta?.link && cta?.label && (
              <Link to={cta?.link} className="btn-link" target={cta?.target}>
                {cta.label}
              </Link>
            )}
          </div>
          <div className="info-container__children">
            <Accordion items={sortedItems} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Info;
export const fragment = graphql`
  fragment InfoModuleFragment on LiferayInfoModule {
    id
    liferayFields {
      siteId
      articleId
    }
    infoTitle: title
    preTitle
    abstract
    anchorTitleDesktop
    anchorTitleMobile
    cta {
      label
      link
      target
    }
    accordion {
      accordionTitle
      accordionText
      accordionImageDesktop {
        value {
          description
        }
        node {
          publicURL
          gatsbyImageData(width: 620, layout: CONSTRAINED)
        }
      }
      accordionImageMobile {
        value {
          description
        }
        node {
          publicURL
          gatsbyImageData(width: 620, layout: CONSTRAINED)
        }
      }
      position
    }
  }
`;
